/* ============================================================
   Spangle — Upsell add-to-cart (product page + cart drawer/page)
   ------------------------------------------------------------
   Adds a single-variant upsell product to the cart via AJAX and
   re-renders the theme's cart drawer using the SAME mechanism the
   theme already uses (CartDrawer.renderContents), so cart logic,
   the free-shipping bar, and the cart count all stay correct.

   Multi-variant products are rendered as links (not buttons) in
   Liquid, so this script only ever handles safe single-variant adds.
   ============================================================ */
(function () {
  'use strict';

  // Guard against double-initialisation (avoids duplicate add-to-cart).
  if (window.__spangleUpsellInit) return;
  window.__spangleUpsellInit = true;

  function onCartPage() {
    return !!(document.querySelector('cart-items') || document.getElementById('main-cart-items'));
  }

  function restore(btn, label) {
    btn.removeAttribute('aria-busy');
    btn.classList.remove('is-added');
    btn.textContent = label;
  }

  document.addEventListener('click', function (event) {
    var btn = event.target.closest('.spangle-upcard__add[data-variant-id]');
    if (!btn || btn.disabled) return;

    event.preventDefault();

    var variantId = btn.getAttribute('data-variant-id');
    if (!variantId) return;

    var originalLabel = btn.textContent;
    var routes = window.routes || {};
    var addUrl = routes.cart_add_url || '/cart/add';
    var cartUrl = routes.cart_url || '/cart';
    var cartDrawer = document.querySelector('cart-drawer');

    btn.setAttribute('aria-busy', 'true');

    var sectionIds = [];
    if (cartDrawer && typeof cartDrawer.getSectionsToRender === 'function') {
      sectionIds = cartDrawer.getSectionsToRender().map(function (s) { return s.id; });
    }

    var body = {
      id: Number(variantId),
      quantity: 1
    };
    if (sectionIds.length) {
      body.sections = sectionIds.join(',');
      body.sections_url = window.location.pathname;
    }

    fetch(addUrl, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/javascript'
      },
      body: JSON.stringify(body)
    })
      .then(function (response) { return response.json(); })
      .then(function (data) {
        // Shopify returns a status field on error (e.g. sold out)
        if (data && (data.status === 422 || data.status === 404 || data.status === 'bad_request')) {
          window.location.href = cartUrl;
          return;
        }

        btn.classList.add('is-added');
        btn.textContent = 'Added ✓';

        // On the dedicated cart page, reload so the line items update.
        if (onCartPage()) {
          window.location.reload();
          return;
        }

        // Otherwise re-render + open the drawer exactly like the theme does.
        if (cartDrawer && data.sections && typeof cartDrawer.renderContents === 'function') {
          cartDrawer.renderContents(data);
          // Let other components (e.g. cart count) know, if the theme uses pub/sub.
          if (window.PUB_SUB_EVENTS && typeof publish === 'function') {
            try { publish(PUB_SUB_EVENTS.cartUpdate, { source: 'spangle-upsell' }); } catch (e) {}
          }
          setTimeout(function () { restore(btn, originalLabel); }, 2500);
        } else {
          // No drawer available — fall back to the cart page.
          window.location.href = cartUrl;
        }
      })
      .catch(function () {
        window.location.href = cartUrl;
      });
  });
})();
